export const Weblabs = {
    gapsVendorCentralDefaultMode: 'GAPS_VC_DEFAULT_MODE_1304128',
};
